var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasElementProps)?_c('div',{staticClass:"icon-element"},[_c('a-icon',{attrs:{"spin":_vm.elementProps.spin,"rotate":_vm.elementProps.rotate,"theme":_vm.elementProps.theme,"type":_vm.elementProps.type}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }